import { createSlice } from "@reduxjs/toolkit";

import { LocationSlice } from "./types";
import { LocationEntity } from "../../api/Locations";

export const initialState: LocationEntity = {
  locationName: "",
  bmName: "",
  address: "",
  phone: "",
  ext: "",
  email: "",
  manager: {
    name: "",
    phone: "",
    position: "",
  },
  personInCharge: [],
  vision: "",
  mission: [],
  strategy: [],
  imageName: "",
  imageUrl: "",
  locationId: "",
};

export const locationSlice = createSlice({
  name: "locationSlice",
  initialState,
  reducers: {
    setLocation: (state, action) => action.payload,
  },
});

export const { setLocation } = locationSlice.actions;
export const locationReducer = locationSlice.reducer;
